import React, { useEffect } from "react";
import AOS from "aos";
import Slider from "react-slick";
import SectionTitle from "../SectionTitle/SectionTitle";
import PortofolioCard from "./PortofolioCard";
import portofolio from "../../api/portofolio";

const PortofolioSection = (props) => {
  useEffect(() => {
    AOS.init({
      offset: 200,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  const settings = {
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    speed: 500,
    dots: true,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <section className={"section-padding " + props.hclass} id="portofolio">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12" data-aos="fade-up">
            <SectionTitle
              subtitle="Portofolio Kami"
              title="Produk Unggulan Kami"
            />
          </div>
        </div>
      </div>
      <div className="project-slider" data-aos="fade-left">
        <Slider {...settings}>
          {portofolio.map((item, Pindx) => (
            <div key={Pindx}>
              <PortofolioCard
                Pimg={item.img}
                Psubtitle={item.creator}
                Ptitle={item.name}
                Plink={item.link}
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default PortofolioSection;
